import Box from '@mui/material/Box';
import { Button } from '../../shared/components/button/Button';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { Home } from '../../routes/RoutesNames';
import { useAjuda } from './Ajuda/useAjuda';
import { AjudaDrawer } from './Ajuda/AjudaDrawer';

interface HeaderComponentProps {
  text: string;
  className?: string;
  ButtonRight?: React.ReactNode;
  // [30/09] Para onde o Fechar leva, quando a regra padrao (abaixo) erra o destino. Ex.: o
  // detalhe do pedido (/pedido/:id/detalhe) nao tem "cadastrar" no caminho e iria para a Home,
  // e o esperado e a listagem de pedidos. Opcional: quem nao informa fica como sempre foi.
  onClose?: () => void;
}
export const HeaderComponent = ({ text, ButtonRight, className, onClose }: HeaderComponentProps) => {
  const navigate = useNavigate();

  // [NOVO 21/08/2026] Ajuda da tela. Mora AQUI porque 38 telas já usam este cabeçalho -
  // nenhuma delas precisou mudar, e nao ha Provider nem alteracao no App.tsx.
  //
  // O botao aparece SO quando a rota tem texto no registro (src/.../Ajuda/conteudo). Um "?"
  // que abre "sem ajuda para esta tela" em 79 de 85 rotas seria pior do que nao ter botao -
  // e e o que torna viavel comecar por poucas telas.
  //
  // O botao e VISIVEL de proposito, e nao so o atalho F1: ninguem descobre atalho em sistema
  // web, e neste sistema affordance invisivel ja gerou chamado (o "Gerar Recibos" que so
  // explicava no hover virou "parou de funcionar" em 18/08).
  const ajuda = useAjuda();

  return (
    <Box 
      style={{ marginTop: '12px' }} 
      className={`grid grid-cols-3 items-center py-3 px-4 relative rounded-xl bg-[#707070] ${className}`}
    >
      {/* Coluna 1: Botão Voltar (+ Ajuda, quando a tela tem) */}
      <Box className="flex justify-start items-center gap-2">
        <Button 
          title={'Fechar'}
          iconStart={<Icon.ArrowBack />}
          variant='primary'
          onClick={() => {
            if (onClose) return onClose();
            const p = window.location.pathname;
            setTimeout(() => {
              if(!p.includes('cadastrar')) {
                return navigate(Home, {replace: true});
              }
              navigate(-1);
            }, 10);
          }}
        />

        <Button
          title={'Ajuda'}
          iconStart={<Icon.HelpOutline />}
          variant='secondary'
          onClick={ajuda.abrir}
        />
      </Box>

      {/* Coluna 2: Título (Sempre no centro da grid) */}
      <h2 className={'text-white font-bold text-xl uppercase text-center whitespace-nowrap'}>
        {text}
      </h2>

      {/* Coluna 3: Botão Opcional (Alinhado à direita) */}
      {/* [01/10] flex-wrap + gap: tela de Vendas tem 5 botoes, e numa tela menor eles se
          espremiam na coluna - o icone de um invadia o texto do outro. Agora o que nao
          cabe desce para uma segunda linha. Em tela larga nada muda. */}
      <Box className="flex justify-end flex-wrap gap-2">
        {ButtonRight && ButtonRight}
      </Box>

      <AjudaDrawer
        aberto={ajuda.aberto}
        fechar={ajuda.fechar}
        conteudo={ajuda.conteudo}
        carregando={ajuda.carregando}
        semAjuda={ajuda.semAjuda}
      />
    </Box>
  );
};
